var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.137 10.96a6.16 6.16 0 0 1-6.158 6.16 6.16 6.16 0 0 1-6.157-6.16A6.16 6.16 0 0 1 10.98 4.8c3.4 0 6.157 2.757 6.157 6.16m-1.223 6.06a7.815 7.815 0 0 1-12.748-6.06 7.815 7.815 0 0 1 7.813-7.816c4.316 0 7.814 3.499 7.814 7.816 0 1.846-.64 3.543-1.71 4.88l.38.437 3.167 3.63a.828.828 0 1 1-1.248 1.088l-3.166-3.629z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;